 <template>
	<nav class="mainmenu-area stricky">
		<div class="container">
			<div class="navigation pull-left">
				<div class="nav-header">
					<ul>
						<li v-for="(link,value) in nav" :class="{cur: check(link,$route.name)}" @click="redirect(link)">
							<a href="javascript:void(0);">{{value}}</a>
						</li>
					</ul>
				</div>
				<div class="nav-footer">
					<button>
						<i class="fa fa-bars"></i>
						<p>栏目导航</p>
					</button>
					<div class="nav-btn"></div>
				</div>
			</div>
			<!-- 移动端icon -->
			<div class="navigation-right-list">
				<div class="navigation-right pull-right">
					<a href="javascript:void(0);" class="nav-footer" @click="goBottom">
						<button>
							<i class="fa fa-envelope"></i>
							<p>一键留言</p>
						</button>
						<div class="nav-btn"></div>
					</a>
				</div>
				<div class="navigation-right pull-right">
					<a :href="'tel:'+systemInfo.company_mobile" class="nav-footer">
						<button>
							<i class="fa fa-phone"></i>
							<p>一键电话</p>
						</button>
						<div class="nav-btn"></div>
					</a>
				</div>
				<div class="navigation-right pull-right">
					<a :href="mapSrc" class="nav-footer">
						<button>
							<i class="fa fa-map-marker"></i>
							<p>一键导航</p>
						</button>
						<div class="nav-btn"></div>
					</a>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</nav>

</template>

<script>
	import { mapGetters } from 'vuex';
	import data from "@/assets/js/data.js";
	export default {
		name: "page-nav",
		data(){
			return {
				nav: data.nav,
				mapSrc: ''
			}
		},
		mounted(){
			$(window).on('scroll',function(){
				var strickyScrollPos = 100;
		        if ($(window).scrollTop() > strickyScrollPos) {
		            $('.stricky').removeClass('fadeIn animated');
		            $('.stricky').addClass('stricky-fixed fadeInDown animated');
		        } else if ($(this).scrollTop() <= strickyScrollPos) {
		            $('.stricky').removeClass('stricky-fixed fadeInDown animated');
		            $('.stricky').addClass('slideIn animated');
		        }
			});
		},
		updated(){
			this.initMap({
				coord: this.systemInfo.position_x+","+this.systemInfo.position_y,
				title: this.systemInfo.company_name_cn,
				addr: this.systemInfo.company_address_cn
			});
		},
		methods:{
			//路由检查
			check(links,now){
				return links.split(",").indexOf(now) != -1;
			},
			// 路由导航
			redirect(link){
				this.$router.push({
					name: link.split(',')[0]
				});
			},
			//地图部分
            initMap: function (data) {
                var _this = this;
                var src = 'http://apis.map.qq.com/tools/poimarker?type=0&marker=';
                var key = 'CBHBZ-G3E3P-UI4D2-LIXX3-UG6YV-U6F4D';
                var appName = 'wechat_invitation';
                for (var k in data) {
                    src += k + ':' + data[k] + ';';
                }
                src = src.slice(0, src.length - 1);
                src += '&key=' + key + '&referer=' + appName;
                _this.mapSrc = src;
            },
			goBottom(){
				if($("#footer-cf").length>0){//存在留言则滚动到响应位置
					let top = $("#footer-cf").offset().top;
					$("html,body").animate({
						scrollTop: top
					},1000);
				}else{ //不存在留言则直接跳转到contact页面底部
					localStorage.setItem('isBottom',true);
					this.$router.push({
						name: 'contact'
					});
				}

			}
		},
		computed:{
			...mapGetters(['systemInfo'])
		}
	}
</script>

<style>
	/**
	 * 修改部分
	 */
	.navigation-right-list{
		display: none;
	}
	.navigation-right-list .navigation-right{
		margin-right: 20px;
	}
	.navigation-right-list .navigation-right:first-child{
		margin: 0;
	}
	.navigation-right-list .navigation-right:first-child .nav-footer button{
		margin-right: 0;
	}
	.navigation-right-list .navigation-right .nav-footer button{
		width: 54px;
		height: 54px;
		color: #6aaf08;
		border: 1px solid #6aaf08;
		border-radius: 5px;
		outline: none;
		font-size: 18px;
		margin: 8px 8px 8px 0;
		box-sizing: border-box;
		background: transparent;
	}
	.navigation-right-list .navigation-right .nav-footer button i{
		margin: 0;
		padding-top: 5px;
		font-size: 20px;
	}
	.navigation-right-list .navigation-right .nav-footer button p{
		margin: 0;
		font-size: 10px;
	}

	@media (max-width: 768px){
		.navigation-right-list {
			display: block;
		}
		.header-right-info {
			display: none;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/PageNav.vue